import { Pipe, PipeTransform } from '@angular/core';
import { WeekDays } from '@wilson/interfaces';
import { addDays, differenceInDays, getISODay } from 'date-fns';

@Pipe({
  name: 'disabledWeekdaysRange',
  standalone: false,
})
export class DisabledWeekdaysRangePipe implements PipeTransform {
  transform(timeFrame: { start: Date | string; end: Date | string }): WeekDays {
    let disabledWeekDays: WeekDays = {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    };
    const startDate = new Date(timeFrame.start);
    const endDate = new Date(timeFrame.end);
    const max = Math.min(differenceInDays(endDate, startDate), 6);
    for (let i = 0; i <= max; i++) {
      const date = addDays(startDate, i);
      const isoDay: number = getISODay(date);
      disabledWeekDays = this.disableWeekday(isoDay, disabledWeekDays);
    }
    return disabledWeekDays;
  }

  private disableWeekday(isoDay: number, disabledWeekDays: WeekDays): WeekDays {
    switch (isoDay) {
      case 1:
        disabledWeekDays.monday = true;
        break;
      case 2:
        disabledWeekDays.tuesday = true;
        break;
      case 3:
        disabledWeekDays.wednesday = true;
        break;
      case 4:
        disabledWeekDays.thursday = true;
        break;
      case 5:
        disabledWeekDays.friday = true;
        break;
      case 6:
        disabledWeekDays.saturday = true;
        break;
      case 7:
        disabledWeekDays.sunday = true;
        break;
    }
    return disabledWeekDays;
  }
}
